import { render, staticRenderFns } from "./edition1.vue?vue&type=template&id=dd5321f8&scoped=true"
import script from "./edition1.vue?vue&type=script&lang=js"
export * from "./edition1.vue?vue&type=script&lang=js"
import style0 from "./edition1.vue?vue&type=style&index=0&id=dd5321f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5321f8",
  null
  
)

export default component.exports